import React, { useEffect, useRef } from 'react';
import './BandLanding.css';

function BandLanding() {
  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      if (headerRef.current) {
        headerRef.current.style.backgroundPositionY = scrolled * 0.5 + 'px';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="band-landing">
      <div className="hero" ref={headerRef}>
        <div className="hero-content">
          <h1 className="band-name">The Peatot Band</h1>
          <h2 className="band-name-hebrew">להקת הפיתות</h2>
          <p className="band-tagline">An Israeli Rock Cover Band</p>
        </div>
      </div>

      <section className="band-photo-section">
        <h2>Meet the Band</h2>
        <div className="band-photo">
          <img src="/Yoman-Masa-T1.jpg" alt="The Peatot Band" />
          <div className="band-members-list">
            <div className="member">
              <h3>Mor Perez</h3>
              <p>Lead Vocals</p>
            </div>
            <div className="member">
              <h3>Guy Livneh</h3>
              <p>Keyboard</p>
            </div>
            <div className="member">
              <h3>Raviv Moore</h3>
              <p>Guitar</p>
            </div>
            <div className="member">
              <h3>Anton Plotkin</h3>
              <p>Bass</p>
            </div>
            <div className="member">
              <h3>Tomer Dichterman</h3>
              <p>Drums</p>
            </div>
            <div className="member">
              <h3>Itzik Lerner</h3>
              <p>Saxophone</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <h2>About Us</h2>
        <p>The Peatot plays tribute to Israeli popular music from the past 5 decades. 
           We deliver a unique, exciting, and uplifting celebration of the music that we love. 
           Based out of the San Francisco bay area, The Peatot have toured the USA bringing 
           their Israeli party experience to Jewish and Israeli expat communities.</p>
        <p>Our repertoire includes a vibrant collection of rock, pop, and oriental music 
           that embodies the unique Israeli musical palette.</p>
      </section>

      <section className="contact-section">
        <h2>Get in Touch</h2>
        <div className="contact-info">
          <p><strong>Email:</strong> <a href="mailto:thepeatot@gmail.com">thepeatot@gmail.com</a></p>
          <p><strong>Follow Us:</strong> <a href="https://www.facebook.com/thepeatot" target="_blank" rel="noopener noreferrer">Facebook</a></p>
        </div>
      </section>

      <footer className="band-footer">
        <p>© {new Date().getFullYear()} The Peatot Band. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default BandLanding; 